import { useMemo } from 'react';

import { DeliveryNote } from '@work4all/models/lib/Classes/DeliveryNote.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import { useErpTable } from './offers-table/erp-common/use-erp-table';
import { useCloneConvertErpActions } from './offers-table/hooks/use-clone-convert-erp';
import schema from './schemata/deliveryNote-table-schema.json';
import { useErpHandlersTemplateV8 } from './use-erp-handlers-template-v8';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

const secondarySort = [
  { field: 'number', direction: SortDirection.DESCENDING },
];

const FORCE_REQUEST_FIELDS: DeliveryNote<EMode.query> = {
  positionList: [{ id: null, originalId: null }],
};

export function DeliveryNotesTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<DeliveryNote, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    secondarySort,
    forceRequestFields: FORCE_REQUEST_FIELDS,
    enableFooter: true,
    rowModifiers: (value) => {
      return {
        isFaded: value.isClosed && value.frozen,
        isShade1: !value.isClosed && value.frozen,
      };
    },
  });

  const template = useErpHandlersTemplateV8(dataTable.table);

  const { actions } = useCloneConvertErpActions({
    entity: Entities.deliveryNote,
    data: dataTable.selectedEntities,
  });
  useErpTable(Entities.deliveryNote, dataTable.data.length === 0);

  const custom = useMemo(
    () => ({
      left: actions,
    }),
    [actions]
  );

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      template={template}
      actions={{ custom }}
      displayFooter
    />
  );
}
